import { fromJS, List, Map } from 'immutable';
import { get } from 'lodash';

import {
  DOWNLOAD_PDF_ACTIONS,
  GET_REFUNDS_AMC,
  GET_REFUNDS_AMC_FAILED,
  GET_REFUND_AMC_DETAILS,
  GET_REFUND_AMC_DETAILS_FAILED,
  GET_SINISTRES,
  GET_SINISTRES_FAILED,
  GET_SINISTRE_DETAILS,
  GET_SINISTRE_DETAILS_FAILED,
  RESET_GET_REFUNDS_AMC,
  SET_REFUNDS_AMC,
  SET_REFUND_AMC_DETAILS,
  SET_SINISTRES,
  SET_SINISTRE_DETAILS,
} from 'store/sinistre/constants';

export const buildData = (data: any, serverData: any) => {
  const keys = Object.keys(data);
  Object.keys(serverData).forEach((key) => {
    if (!keys.includes(key)) {
      keys.push(key);
    }
  });
  return keys.reduce(
    (acc: any, key: string) => ({
      ...acc,
      [key]: [...get(data, key, []), ...get(serverData, key, [])],
    }),
    {},
  );
};

export const initialState = fromJS({
  sinistres: [],
  sinistreDetails: [],
  hasError: null,
  isLoading: false,
  refundsAMC: {},
  isRefundsLoading: false,
  isRefundDetailLoading: false,
  errorMessageGetRefundsAMC: null,
  refundDetail: {},
  errorMessageGetRefundDetails: null,
  total: 0,
  page: 0,
  downloadPdfLoading: false,
  downloadPdfError: null,
  downloadPdfData: '',
});

type ActionType = {
  type: string;
  payload: any;
  error: any;
};

export default function reducer(state = initialState, action: ActionType) {
  switch (action.type) {
    case GET_SINISTRES:
      return state.set('isLoading', true).set('hasError', null);
    case SET_SINISTRES:
      return state
        .set('sinistres', List(action.payload))
        .set('isLoading', false);
    case GET_SINISTRES_FAILED:
      return state.set('isLoading', false).set('hasError', true);
    case GET_SINISTRE_DETAILS:
      return state.set('isLoading', true).set('hasError', null);
    case SET_SINISTRE_DETAILS:
      return state
        .set('sinistreDetails', List(action.payload))
        .set('isLoading', false);
    case GET_SINISTRE_DETAILS_FAILED:
      return state.set('isLoading', false).set('hasError', true);
    case GET_REFUNDS_AMC:
      return state.set('isRefundsLoading', true);
    case SET_REFUNDS_AMC: {
      const data = state.get('refundsAMC').toJS();
      const result = buildData(data, action.payload.data);
      return state
        .set('refundsAMC', Map(result))
        .set('total', action.payload.total)
        .set('page', state.get('page') + 1)
        .set('isRefundsLoading', false);
    }
    case GET_REFUNDS_AMC_FAILED:
      return state
        .set('isRefundsLoading', false)
        .set('errorMessageGetRefundsAMC', action.payload);
    case RESET_GET_REFUNDS_AMC:
      return state
        .set('refundsAMC', Map({}))
        .set('total', 0)
        .set('page', 0)
        .set('isRefundsLoading', false);
    case GET_REFUND_AMC_DETAILS:
      return state.set('isRefundDetailLoading', true);
    case SET_REFUND_AMC_DETAILS:
      return state
        .set('refundDetail', action.payload.data)
        .set('isRefundDetailLoading', false);
    case GET_REFUND_AMC_DETAILS_FAILED:
      return state
        .set('isRefundDetailLoading', false)
        .set('errorMessageGetRefundDetails', action.payload);

    case DOWNLOAD_PDF_ACTIONS.START:
      return state.set('downloadPdfLoading', true);
    case DOWNLOAD_PDF_ACTIONS.SUCCESS:
      return state
        .set('downloadPdfLoading', false)
        .set('downloadPdfError', null)
        .set('downloadPdfData', action.payload);
    case DOWNLOAD_PDF_ACTIONS.FAIL:
      return state
        .set('downloadPdfLoading', false)
        .set('downloadPdfError', action.error)
        .set('downloadPdfData', '');
    case DOWNLOAD_PDF_ACTIONS.RESET:
      return state
        .set('downloadPdfLoading', false)
        .set('downloadPdfError', null)
        .set('downloadPdfData', '');
    default:
      return state;
  }
}
